<template>
  <div id="tab-afr" class="afr-info">
    <!--AMS按钮：数据抄录/同步HBL信息/代码检索...-->
    <div v-if="showCodeSearch" class="section operations">
      <div v-show="cooperateEdit" class="triggers">
        <div>
          <el-dropdown
            style="padding-left: 5px;"
            :class="readonly?'not-click':''"
            split-button
            type="primary"
            no="1"
            @click="commandHandle(command1)"
            @command="p=>{command1=p;commandHandle(command1);}"
          >
            {{ this.getItemTitle(command1) }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="Copy Last Time" :title="$t('SeaExport.CopyLast')">{{ this.getItemTitle('Copy Last Time') }}</el-dropdown-item>
              <el-dropdown-item command="Copy By File NO" :title="$t('SeaExport.WaybillNumberCopy')">{{ this.getItemTitle('Copy By File NO') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-radio-group v-if="isJs" v-model="saveAs" style="margin-left: 20px;">
            <el-radio label="1">{{ $t('SeaExport.CargoWare') }}</el-radio>
            <el-radio label="2">{{ $t('SeaExport.Other') }}</el-radio>
          </el-radio-group>
        </div>
      </div>
    </div>
    <!--收发通信息/货物信息/运输信息/其他信息-->
    <div style="width: fit-content">
      <div style="display: flex">
        <!--收发通信息-->
        <afr-address-format-form
          :job="job"
          :show-second-notify-party="showSecondNotifyParty"
          :readonly="readonly"
          :local-data="localData"
          :address-form="form.afrAddress[0] || {}"
          :tab-name="tabName"
          :is-js="isJs"
          :js-send-hide="jsSendHide"
          @showSenderAndReceiverDialog="showSenderAndReceiverDialog"
          @selectionItemHandlerByType="p=>{pm.selectionItemHandlerByType(p)}"
        />
        <!--货物信息-->
        <div class="section form-column">
          <el-form :disabled="readonly" label-width="112px" label-position="right" style="height:100%">
            <span class="title" :title="$t('SeaExport.CargoInformation')">{{ getItemTitle('Cargo Information') }}</span>
            <el-form-item :label="getItemTitle('HB/L NO')" :title="$t('SeaExport.HBLNumber')" :class="isDifferent('hblNbr2')">
              <el-input v-model="form.hblNbr2" no="2" @input="hblNbr2Change" />
            </el-form-item>
            <el-form-item :title="$t('SeaExport.BillOfLadingQuantity')" :label="getItemTitle('Quantity')" :class="isDifferent('quantity')">
              <auto-number-input
                v-model="form.quantity"
                no="3"
                :precision="0"
                :min="0"
              />
            </el-form-item>
            <el-form-item :title="$t('SeaExport.Packing')" :label="getItemTitle('Unit Type')" :class="isDifferent('packing')">
              <span slot="label">
                <el-tooltip
                  :content="$t('CargoMsg.Cargo_AmsUnitTypeTip')"
                  placement="right-end"
                >
                  <i
                    class="el-icon-question"
                    style="cursor: pointer;color: #1F75D5;"
                  />
                </el-tooltip>
                {{ getItemTitle('Unit Type') }}
              </span>
              <cargo-packing-select
                v-if="!jsSendHide"
                :default-value="form.packing"
                style="width:100%;"
                no="4"
                @change="changeUnitType"
              />
              <cargo-advance-select
                v-else
                no="4"
                :static-options="localData.jsAfrPacking"
                :custom-label="(item)=>`[${item.code}]${item.name}`"
                :cache="false"
                filterable
                :default-value="form.packing||''"
                :filter-tag-names="['name', 'code']"
                tag-name="name"
                tag-value="code"
                @parentCallBack="changeUnitType"
              />
            </el-form-item>
            <el-form-item :title="$t('SeaExport.GrossWeight')" :label="getItemTitle('Gross Weight')">
              <div style="display: flex">
                <el-input-number
                  v-if="!jsSendHide"
                  v-model="form.weight"
                  :class="isDifferent('weight')"
                  :precision="3"
                  :controls="false"
                  style="flex: 1"
                  no="5"
                />
                <el-input-number
                  v-else
                  v-model="form.weight"
                  :class="isDifferent('weight')"
                  :precision="3"
                  :controls="false"
                  style="flex: 1"
                  :max="999999.999"
                  no="5"
                />
                <span>KGS</span>
              </div>
            </el-form-item>
            <el-form-item :title="$t('SeaExport.Cubage')" :label="getItemTitle('Volume')">
              <div style="display: flex">
                <el-input-number
                  v-if="!jsSendHide"
                  v-model="form.cubage"
                  :class="isDifferent('cubage')"
                  :precision="3"
                  :controls="false"
                  style="flex: 1"
                  no="6"
                />
                <el-input-number
                  v-else
                  v-model="form.cubage"
                  :class="isDifferent('cubage')"
                  :precision="3"
                  :controls="false"
                  style="flex: 1"
                  no="6"
                  :max="999999.999"
                />
                <span>CBM</span>
              </div>
            </el-form-item>
            <el-form-item label="HS CODE">
              <el-input v-model="form.hsCode" no="7" @change="hsCodeInputChanged" />
            </el-form-item>
            <el-form-item :label="getItemTitle('County of Origin')" :title="$t('SeaExport.CountryOfOrigin')">
              <cargo-advance-select
                v-if="!jsSendHide"
                no="countryOrigin"
                :select-type="TYPE_NAMES.basic_data_Country"
                tag-name="code"
                filterable
                :default-value="form.countryOrigin"
                @parentCallBack="p=>{form.countryOrigin=p.value;setNameOfCountry(p)}"
              />
              <cargo-advance-select
                v-else
                no="countryOrigin"
                :static-options="localData.jsCountry"
                :cache="false"
                :default-value="form.countryOrigin"
                filterable
                clearable
                :filter-tag-names="['code']"
                tag-name="code"
                tag-value="code"
                @parentCallBack="p=>{form.countryOrigin=p.value;localData.nameOfCountry=p.name}"
              />
              <el-input v-model="localData.nameOfCountry" />
            </el-form-item>
            <el-form-item v-show="!jsSendHide" :label="getItemTitle('Deliv.Mode')">
              <cargo-advance-select
                no="freightTerm"
                filterable
                :default-value="form.freightTermHBL"
                :cache="false"
                tag-name="chineseName"
                tag-value="code"
                :filter-tag-names="['code','chineseName']"
                :static-options="SystemConstants.AMS_FREIGHT_TERM"
                @parentCallBack="p=>{form.freightTermHBL=p.value;}"
              />
            </el-form-item>
            <el-form-item :label="getItemTitle('Place of Receipt')" :title="$t('SeaExport.BillLadingPlaceOfDispatch')">
              <cargo-advance-select
                v-if="!jsSendHide"
                :select-type="TYPE_NAMES.basic_data_Seaport"
                filterable
                :default-value="form.dispatchingPlaceCode"
                tag-name="englishName"
                style="flex:1"
                no="8"
                @parentCallBack="p=>{portChange(p, 'dispatchingPlaceCode', 'dispatchingPlace')}"
              />
              <cargo-advance-select
                v-else
                no="8"
                :static-options="localData.jsAfrPortList"
                :custom-label="(item)=>`[${item.code}]${item.name}`"
                :cache="false"
                filterable
                :default-value="form.dispatchingPlaceCode||''"
                :filter-tag-names="['name', 'code']"
                tag-name="name"
                tag-value="code"
                @parentCallBack="p=>{portChange2(p, 'dispatchingPlaceCode', 'dispatchingPlace')}"
              />
              <el-input v-model="form.dispatchingPlace" />
            </el-form-item>
            <el-form-item :label="getItemTitle('Place of Delivery')" :title="$t('SeaExport.BillLadingPlaceOfDelivery')" :class="isDifferent('destinationPortCode')">
              <cargo-advance-select
                v-if="!jsSendHide"
                :select-type="TYPE_NAMES.basic_data_Seaport"
                filterable
                :default-value="form.destinationPortCode||''"
                tag-name="englishName"
                no="9"
                @parentCallBack="p=>{portChange(p, 'destinationPortCode', 'destinationPort')}"
              />
              <cargo-advance-select
                v-else
                no="23"
                :static-options="localData.jsAfrPortList"
                :custom-label="(item)=>`[${item.code}]${item.name}`"
                :cache="false"
                filterable
                :default-value="form.destinationPortCode||''"
                :filter-tag-names="['name', 'code']"
                tag-name="name"
                tag-value="code"
                @parentCallBack="p=>{portChange2(p, 'destinationPortCode', 'destinationPort')}"
              />
              <el-input v-model="form.destinationPort" />
            </el-form-item>
            <el-form-item v-if="jsSendHide" :label="getItemTitle('Cargo Type')">
              <el-select v-model="form.goodsType" no="50">
                <el-option label="General Cargo" :value="0" />
                <el-option label="Dangerous Cargo" :value="1" />
              </el-select>
            </el-form-item>
            <el-form-item v-if="jsSendHide && isDangerousCargo" title="Hazardous code" :label="getItemTitle('Hazardous code')">
              <cargo-advance-select
                v-if="jsSendHide"
                no="51"
                :static-options="localData.jsAfrDangerous"
                :cache="false"
                filterable
                :default-value="form.hazardousCode||''"
                :filter-tag-names="['code']"
                tag-name="code"
                tag-value="code"
                @parentCallBack="p=>{form.hazardousCode = p.value}"
              />
            </el-form-item>
            <el-form-item v-if="jsSendHide && isDangerousCargo" :label="getItemTitle('IMDG Class')">
              <el-input v-model="form.imdgClass" no="52" />
            </el-form-item>
            <el-form-item v-if="jsSendHide && isDangerousCargo" label="UN No.">
              <el-input v-model="form.unNo" no="53" />
            </el-form-item>
            <el-form-item v-if="jsSendHide" label-width="0" :title="$t('SeaExport.EnglishCommodityName')"><span>{{ getItemTitle('Commodity Decription') }}</span></el-form-item>
            <el-form-item v-if="jsSendHide" class="auto-width" label-width="0">
              <cargo-rich-textarea
                v-model="form.cargoEnglishName"
                :class="isDifferent('cargoEnglishName')"
                :disabled="!isEdit"
                :text-chars="0"
                wrap-symbol="r"
                auto-uppercase
                auto-half-word
                style="height: 110px"
                :warning-count="-1"
                no="9"
              />
            </el-form-item>
            <el-form-item v-if="jsSendHide" label-width="0"><span>{{ getItemTitle('Marks') }}</span></el-form-item>
            <el-form-item v-if="jsSendHide" class="auto-width" label-width="0">
              <cargo-rich-textarea
                v-model="form.mark"
                :text-chars="0"
                :maxlength="300"
                :disabled="!isEdit"
                type="textarea"
                :rows="5"
                no="55"
              />
            </el-form-item>
            <el-form-item v-show="!jsSendHide" label-width="0" :title="$t('SeaExport.Remarks')"><span>{{ getItemTitle('Remark (max 300 letters)') }}</span></el-form-item>
            <el-form-item v-show="!jsSendHide" class="auto-width" label-width="0">
              <el-input
                v-model="form.remarks"
                :maxlength="300"
                :disabled="!isEdit"
                type="textarea"
                :rows="5"
                no="10"
              />
            </el-form-item>
          </el-form>
        </div>
        <!--运输信息-->
        <div class="section form-column">
          <el-form :disabled="readonly" label-width="116px" label-position="right" style="height:100%">
            <span class="title" :title="$t('SeaExport.TransportationInformation')">{{ getItemTitle('Shipping Information') }}</span>
            <el-form-item label-width="0">
              <el-button type="primary" :title="$t('SeaExport.SynchroniseBooking')" no="11" @click="pm.onSyncBooking()">{{ getItemTitle('Synchronise Booking') }}</el-button>
            </el-form-item>
            <el-form-item :label="getItemTitle('MB/L NO')" :title="$t('SeaExport.MBLNumber')" :class="isDifferent('mbl')">
              <el-input v-model="form.mbl" no="12" @change="pm.syncAfrInfo('mbl')" />
            </el-form-item>
            <el-form-item :label="getItemTitle('Vessel')" :title="$t('SeaExport.ShipName')" :class="isDifferent('vessel')">
              <el-input v-model="form.vessel" no="13" @change="pm.syncAfrInfo('vessel')" />
            </el-form-item>
            <el-form-item v-show="jsSendHide" :label="getItemTitle('Vessel Code')" :class="isDifferent('Vessel Code')">
              <el-input v-model="form.vesselCode" no="57" @change="pm.syncAfrInfo('vesselCode')" />
            </el-form-item>
            <el-form-item :label="getItemTitle('Voyage')" :title="$t('SeaExport.Voyage')" :class="isDifferent('voyageFlight')">
              <cargo-rich-textarea
                v-model="form.voyageFlight"
                :disabled="readonly"
                :text-chars="0"
                :warning-count="10"
                :is-trim="true"
                style="min-height: unset;"
                no="14"
                @change="changeVoyage"
              />
            </el-form-item>
            <el-form-item v-show="jsSendHide" :label="getItemTitle('Vessel country flag')">
              <cargo-advance-select
                no="54"
                :select-type="TYPE_NAMES.basic_data_Country"
                :cache="false"
                filterable
                :default-value="form.nationalityCodeofVessel"
                :filter-tag-names="['code','chineseName','name']"
                tag-name="code"
                tag-value="code"
                @parentCallBack="p=>{form.nationalityCodeofVessel = p.value}"
              />
            </el-form-item>
            <el-form-item v-show="!jsSendHide" :label="getItemTitle('IMO')" :title="$t('SeaExport.ShipNumber')" :class="isDifferent('vesselIMO')">
              <el-input v-model="form.vesselIMO" no="15" @change="pm.syncAfrInfo('vesselIMO')" />
            </el-form-item>
            <el-form-item v-show="!jsSendHide" :label="getItemTitle('Call Sign')" :title="$t('SeaExport.BookingShipCallSign')" :class="isDifferent('vesselCode')">
              <el-input v-model="form.vesselCode" no="16" @change="pm.syncAfrInfo('vesselCode')" />
            </el-form-item>
            <el-form-item :label="getItemTitle('ETD')" :title="$t('SeaExport.DateOfDeparture')" :class="isDifferent('etd')">
              <el-date-picker v-if="jsSendHide" v-model="form.etd" type="datetime" value-format="yyyy-MM-dd HH:mm" style="width:100%;" no="17" @change="pm.syncAfrInfo('etd')" />
              <el-date-picker v-else v-model="form.etd" type="date" value-format="yyyy-MM-dd" style="width:100%;" no="17" @change="pm.syncAfrInfo('etd')" />
            </el-form-item>
            <el-form-item :label="getItemTitle('ETA')" :title="$t('SeaExport.ArrivalDate')" :class="isDifferent('eta')">
              <el-date-picker v-model="form.eta" type="date" value-format="yyyy-MM-dd" style="width:100%;" no="18" @change="pm.syncAfrInfo('eta')" />
            </el-form-item>
            <el-form-item :label="getItemTitle('Place of Loading')" :title="$t('SeaExport.BillLadingPortOfDeparture')" :class="isDifferent('loadingPortCode')">
              <cargo-advance-select
                v-if="!jsSendHide"
                :select-type="TYPE_NAMES.basic_data_Seaport"
                filterable
                :default-value="form.loadingPortCode||''"
                tag-name="englishName"
                no="19"
                @parentCallBack="p=>{portChange(p, 'loadingPortCode', 'loadingPort')}"
              />
              <cargo-advance-select
                v-else
                no="23"
                :static-options="localData.jsAfrPortList"
                :custom-label="(item)=>`[${item.code}]${item.name}`"
                :cache="false"
                filterable
                :default-value="form.loadingPortCode||''"
                :filter-tag-names="['name', 'code']"
                tag-name="name"
                tag-value="code"
                @parentCallBack="p=>{portChange2(p, 'loadingPortCode', 'loadingPort')}"
              />
              <el-input v-model="form.loadingPort" />
            </el-form-item>
            <el-form-item :label="getItemTitle('Place of Discharge')" :title="$t('SeaExport.BillLadingPortOfDischarge')" :class="isDifferent('dischargingPortCode')">
              <cargo-advance-select
                v-if="!jsSendHide"
                :select-type="TYPE_NAMES.basic_data_Seaport"
                filterable
                :default-value="form.dischargingPortCode||''"
                tag-name="englishName"
                no="20"
                @parentCallBack="p=>{portChange(p, 'dischargingPortCode', 'dischargingPort')}"
              />
              <cargo-advance-select
                v-else
                no="23"
                :static-options="localData.jsAfrPortList"
                :custom-label="(item)=>`[${item.code}]${item.name}`"
                :cache="false"
                filterable
                :default-value="form.dischargingPortCode||''"
                :filter-tag-names="['name', 'code']"
                tag-name="name"
                tag-value="code"
                @parentCallBack="p=>{portChange2(p, 'dischargingPortCode', 'dischargingPort')}"
              />
              <el-input v-model="form.dischargingPort" no="21" />
            </el-form-item>
          </el-form>
        </div>
        <!--其他信息-->
        <div class="section form-column">
          <el-form :disabled="readonly" label-width="100px" label-position="left" style="height:100%">
            <span class="title" :title="$t('SeaExport.OtherInformation')">{{ getItemTitle('Other') }}</span>
            <el-form-item v-show="!jsSendHide" label-width="0" class="auto-width">
              <cargo-ag-grid
                :grid-options="masterInfo.gridOptions"
                :column-defs="masterInfoColumnDefs"
                :row-data="masterInfo.rowData"
                style="width:100%;height:200px"
                @gridReady="params=>{masterInfo.gridApi=params.api}"
              />
            </el-form-item>
            <el-form-item label-width="0" class="auto-width">
              <cargo-ag-grid
                :grid-options="afr2.gridOptions"
                :column-defs="afr2ColumnDefs"
                :row-data="afr2.rowData"
                style="width:100%;height:200px"
                @gridReady="params=>{afr2.gridApi=params.api}"
              />
              <div style="padding:5px 0">
                <div style="float:right">
                  <el-button type="primary" :title="$t('SeaExport.Add2')" no="22" @click="pm.onAddNewAfrCargoDoc()">{{ getItemTitle('Add') }}</el-button>
                  <el-button type="primary" :title="$t('SeaExport.SynchronizeHBLInformation')" no="23" @click="pm.btnSynchroAfrClickHandler()">{{ getItemTitle('Synchronise HB/L') }}</el-button>
                  <el-button type="danger" :title="$t('SeaExport.Delete')" no="24" @click="pm.onRemoveCargoDoc()">{{ getItemTitle('Delete') }}</el-button>
                </div>
              </div>
            </el-form-item>
            <el-form-item :label="getItemTitle('Carrier SCAC')" :title="$t('SeaExport.ShippingCompanySCAC')">
              <el-input :disabled="true" :value="localData.afrCarrierScAc" no="25" />
            </el-form-item>
            <el-form-item v-if="jsSendHide" :label="getItemTitle('Nvocc SCAC')" :title="$t('SeaExport.NonVesselCarrierSCAC')">
              <el-select v-model="form.nvoccScac" filterable :allow-create="true" no="37">
                <el-option
                  v-for="item in localData.nvoccScacList"
                  :key="item"
                  :label="item"
                  :value="item"
                />
              </el-select>
            </el-form-item>
            <el-form-item v-if="!jsSendHide" :label="getItemTitle('Destination Agent')" :title="$t('SeaExport.DestinationAgent')">
              <cargo-advance-select
                no="destinationAgentDoc"
                :select-type="TYPE_NAMES.basic_data_Company"
                filterable
                :method-params="{overseaAgent:true,active:true}"
                :default-value="form.destinationAgentDoc||''"
                placeholder=" "
                @parentCallBack="p=>{form.destinationAgentDoc = p.value;pm.syncAfrInfo('destinationAgentDoc')}"
              />
            </el-form-item>
            <div v-show="!jsSendHide">
              <!-- 新增申报类型 -->
              <span :title="$t('SeaExport.DeclarationType')">{{ getItemTitle('Declare Type') }}</span>
              <el-form-item label-width="0" style="margin-top: 5px">
                <el-radio-group v-model="form.frob" no="26" @change="pm.syncAfrInfo('frob')">
                  <el-tooltip effect="dark" :content="tabName === 'ams' ? $t('SeaExport.DirectToTheUnitedStates'):$t('SeaExport.DirectToCanada')" placement="right" style="display: block">
                    <el-radio :disabled="readonly" label="I" value="I">{{ getItemTitle('Import') }}</el-radio>
                  </el-tooltip>
                  <el-tooltip effect="dark" :content="$t('SeaExport.CargoThroughTheUnitedStates')" placement="right" style="display: block">
                    <el-radio :disabled="readonly" label="F" value="F">{{ getItemTitle('Foreign cargo remaining on-board') }}</el-radio>
                  </el-tooltip>
                </el-radio-group>
              </el-form-item>
            </div>
            <el-form-item v-show="!jsSendHide" :title="$t('SeaExport.FLCLType')" :label="getItemTitle('Consignment Type')" :class="isDifferent('containerLoadType')">
              <el-select
                v-model="form.containerLoadType"
                :placeholder="$t('SeaExport.PleaseChoose')"
                no="27"
                @change="pm.syncAfrInfo('containerLoadType')"
              >
                <el-option
                  v-for="(item,index) in consignmentTypes"
                  :key="index"
                  :label="item"
                  :value="item"
                />
              </el-select>
            </el-form-item>
            <el-form-item v-if="jsSendHide" :label="getItemTitle('Sender Account')">
              <el-input v-model="form.reporterID" :disabled="true" no="56" />
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <div v-show="tabName !== 'isf'" class="section">
      <span class="title" :title="$t('SeaExport.ContainerInformation')">{{ getItemTitle('House Container Information') }}</span>
      <div style="display:flex;flex-direction:column">
        <div v-show="isEdit" style="padding:5px 0">
          <el-button type="primary" :title="$t('SeaExport.AddContainerInformation')" no="28" @click="cargoDocUsageSelectedDialog.visible=true">{{ getItemTitle('Add') }}</el-button>
          <el-button type="danger" :title="$t('SeaExport.RemoveContainerInformation')" no="29" @click="removeContainerUsageClickHandler">{{ getItemTitle('Delete') }}</el-button>
        </div>
        <cargo-ag-grid
          :config-module="'130901'"
          :grid-options="container.gridOptions"
          :column-defs="containerColumnDefs"
          :row-data="containerFinalRowData"
          style="width:100%;height:350px"
          @gridReady="params=>{container.gridApi=params.api}"
        />
      </div>
    </div>
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <cargo-rich-textarea
        ref="advanceTextDialogTextarea"
        v-model="advanceTextDialog.value"
        no="30"
        :text-chars="0"
        :auto-uppercase="advanceTextDialog.isUppercase"
        :auto-half-word="advanceTextDialog.formatObj.autoHalfWord"
        :warning-count="50"
        :disabled="readonly"
        style="height: 198px;"
      />
      <span slot="footer">
        <el-button v-show="isEdit" type="primary" no="31" @click="finishAdvanceText">{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          no="32"
          @click="advanceTextDialog.visible=false"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
    <!-- 回执信息弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="receiptInfoDialog.visible"
      :title="receiptInfoDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <cargo-ag-grid
        :grid-options="receiptInfoDialog.gridOptions"
        :column-defs="receiptInfoDialog.columnDefs"
        :row-data="receiptInfoDialog.rowData"
        style="height:350px"
        @gridReady="params=>{receiptInfoDialog.gridApi=params.api}"
      />
    </el-dialog>
    <!-- 选择装箱信息弹窗 -->
    <cargo-doc-usage-selected-dialog
      :visible.sync="cargoDocUsageSelectedDialog.visible"
      :job="job"
      :doc-type="CargoDocConsts.AFR"
      @callback="cargoDocUsageSelectedDialog.callback"
    />
    <!-- AMS日志弹窗 -->
    <ams-log-view-title-dialog
      :visible.sync="amsLogViewTitleDialog.visible"
      :row-data="amsLogViewTitleDialog.rowData"
    />
    <!-- 单号抄录弹窗 -->
    <afr-address-dialog
      :visible.sync="searchBillNoDialog.visible"
      :params="searchBillNoDialog.params"
      :no-label="amsTitle"
      :no-title="amsTitleCn"
      @selected="p=>{pm.selectionItemHandler(p)}"
    />
    <yf-afr-address-dialog
      :visible.sync="afrSearchBillNoDialog.visible"
      :params="afrSearchBillNoDialog.params"
      :no-label="amsTitle"
      :no-title="amsTitleCn"
      @selected="p=>{pm.selectionItemHandler(p)}"
    />
    <!--选择目的地-->
    <select-sub-loc-dialog
      :visible.sync="selectSubLocDialog.visible"
      :type="selectSubLocDialog.type"
      @select="selectSubLocCallBack"
      @close="()=>selectSubLocDialog.visible=false"
    />
    <!--校验弹框提示-->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="checkDialog.visible"
      :title="checkDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <cargo-ag-grid
        :grid-options="checkDialog.gridOptions"
        :column-defs="checkDialog.columnDefs"
        :row-data="checkDialog.rowData"
        :show-side-bar="false"
        style="height:350px"
        @gridReady="params=>{checkDialog.gridApi=params.api}"
      />
    </el-dialog>
    <!--查看回执-->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="receiptDialog.visible"
      :title="receiptDialog.title"
      width="1000px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <cargo-ag-grid
        :grid-options="receiptDialog.gridOptions"
        :column-defs="columnDefs"
        :row-data="receiptDialog.rowData"
        :show-side-bar="false"
        style="height:350px"
        @gridReady="params=>{receiptDialog.gridApi=params.api}"
      />
    </el-dialog>
  </div>
</template>

<script>
import URL from '@/api/urlTranslator'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoInput from '@/components/Cargo/Common/cargoInput'
import cargoPackingSelect from '@/components/Cargo/Common/cargoPackingSelect'
import cargoDocUsageSelectedDialog from '@/components/Cargo/Job/cargoDocUsageSelectedDialog'
import amsLogViewTitleDialog from '@/components/Cargo/Job/amsLogViewTitleDialog'
import searchBillNoDialog from '@/views/cargo/v0/SeaExport/components/edi/searchBillNoDialog'
import selectSubLocDialog from '@/views/cargo/v0/SeaExport/components/booking/selectSubLocDialog'
import moment from 'moment'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'
import { SeaCargoDoc } from '@/class/model/booking/SeaCargoDoc'
import { formatNumberToThousands } from '@/utils'
import ColumnUtils from '@/utils/ColumnUtils'
import CargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import tabISF10 from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabISF10'
import tabISF05 from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabISF05'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput'
import AddressFormatForm from '@/views/cargo/v0/SeaExport/components/booking/ams/form/addressFormatForm'
import AfrAddressDialog from '@/components/Cargo/Job/afrAddressDialog'
import StrUtils from '@/utils/StrUtils'
import { cache, cacheName } from '@/utils/cacheManager'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import AfrAddressFormatForm from '@/views/cargo/v0/SeaExport/components/booking/ams/form/afrAddressFormatForm.vue'
import YfAfrAddressDialog from '@/components/Cargo/Job/yfAfrAddressDialog.vue'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'

export default {
  name: 'AfrInfo',
  components: {
    YfAfrAddressDialog,
    AfrAddressFormatForm,
    AfrAddressDialog,
    AddressFormatForm,
    CargoRichTextarea, tabISF10, tabISF05, AutoNumberInput,
    cargoAdvanceSelect, cargoInput, cargoPackingSelect, cargoDocUsageSelectedDialog, selectSubLocDialog,
    amsLogViewTitleDialog, searchBillNoDialog
  },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    tabName: {
      type: String,
      required: true
    },
    afr2: { type: Object, default: () => {} },
    masterInfo: { type: Object, default: () => {} },
    container: { type: Object, default: () => {} },
    form: { type: Object, default: () => {} },
    pm: { type: Object, default: () => {} },
    partyNameList: { type: Array, default: () => [] },
    localData: { type: Object, default: () => {} },
    showCodeSearch: { type: Boolean, default: false },
    showSecondNotifyParty: { type: Boolean, default: false },
    cooperateEdit: { type: Boolean, default: true }, // 能否修改
    isJs: { type: Boolean, default: false }
  },
  data() {
    return {
      SystemConstants,
      URL,
      secondGenerationCheck: false,
      visible: false, // 先隐藏，避免组件在初始化完成前，做一些无效的处理（频繁刷新组件、调用接口等）
      moment,
      TYPE_NAMES,
      CargoDocConsts,
      CargoDocUtil,
      maxChars: 34,
      isUppercase: false,
      command1: 'Copy Last Time',
      amsCheck: true,
      txtCarrierScAc: '',
      filingType: 'I',
      consignmentTypes: ['FCL', 'LCL'],
      customerTypes: ['BCO', 'NVO'],
      gdAMS2: {
        rowData: []
      },
      selectSubLocDialog: {
        visible: false,
        type: 1
      },
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        showContact: false,
        extendData: {
          contact: '',
          mobile: '',
          fax: '',
          email: '',
          zipCode: '',
          city: ''
        },
        successCallback: null,
        isUppercase: false,
        formatObj: {
          maxChar: 45
        }
      },
      receiptInfoDialog: {
        visible: false,
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          context: {
            componentParent: this
          }
        },
        columnDefs: [
          {
            headerName: this.$t('SeaExport.receiptDate'),
            colId: 'receiptDate',
            field: 'receiptDate',
            width: 100
          },
          {
            headerName: this.$t('SeaExport.receiptCode'),
            colId: 'receiptCode',
            field: 'receiptCode',
            width: 100
          },
          {
            headerName: this.$t('SeaExport.Content'),
            colId: 'receiptContent',
            field: 'receiptContent',
            width: 100
          }
        ],
        rowData: [],
        gridApi: null
      },
      cargoDocUsageSelectedDialog: {
        visible: false,
        callback: rows => {
          this.pm.usageSelectCallBackFunc(rows)
        }
      },
      amsLogViewTitleDialog: {
        visible: false,
        rowData: []
      },
      billAddressDialog: {
        visible: false
      },
      searchBillNoDialog: {
        visible: false,
        params: {}
      },
      afrSearchBillNoDialog: {
        visible: false,
        params: {}
      },
      checkDialog: {
        visible: false,
        title: this.$t('SeaExport.VerificationPrompt'),
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          context: {
            componentParent: this
          }
        },
        columnDefs: [
          {
            headerName: this.$t('SeaExport.Field'),
            field: 'field',
            width: 250
          },
          {
            headerName: this.$t('SeaExport.ErrorDescription'),
            field: 'errorDescription',
            width: 325
          }
        ],
        rowData: [],
        gridApi: null
      },
      receiptDialog: {
        visible: false,
        title: 'Receipt',
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          context: {
            componentParent: this
          }
        },
        rowData: [],
        gridApi: null
      },
      curAms: null,
      activeTabName: 'tabBookingISF10',
      sendEFTypes: [],
      sendAMSTypes: [],
      cargoDocs: [],
      isTradetech: false,
      saveAs: '1',
      isChineseLanguage: false
    }
  },
  computed: {
    readonly() {
      if (!this.cooperateEdit) return true
      return !this.isEdit
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look' && (!this.form.uuid || this.form.state < 2)
    },
    config() {
      return this.context.config
    },
    job() {
      return this.pm.job
    },
    excelImportDisabled() {
      return this.job.jobState !== 0
    },
    user() {
      return this.context.user || {}
    },
    amsTitle() {
      return this.pm.getNoTitle(false, this.tabName)
    },
    amsTitleCn() {
      return this.pm.getNoTitle(true, this.tabName)
    },
    containerColumnDefs() {
      const columnDefs = [
        {
          headerName: '',
          colId: 'uuid',
          field: '',
          width: 40,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        }, {
          headerName: this.getItemTitle('Container Size'),
          headerTooltip: this.$t('SeaExport.BoxModel'),
          colId: 'eqSize',
          field: 'eqSize',
          width: 160,
          cellRenderer: (params) => {
            return params.value + '\''
          },
          cellStyle: (params) => {
            return this.setCellColor(params.data, params.colDef.field)
          }
        }, {
          headerName: this.getItemTitle('Container No'),
          headerTooltip: this.$t('SeaExport.ContainerNumber'),
          colId: 'containerNo',
          field: 'containerNo',
          width: 160
        }, {
          headerName: this.getItemTitle('Seal No'),
          headerTooltip: this.$t('SeaExport.SealNumber'),
          colId: 'sealNo',
          field: 'sealNo',
          width: 160,
          cellStyle: (params) => {
            return this.setCellColor(params.data, params.colDef.field)
          }
        }, {
          headerName: this.getItemTitle('Gross Weight'),
          headerTooltip: this.$t('SeaExport.GrossWeight'),
          colId: 'weight',
          field: 'weight',
          width: 160,
          cellStyle: (params) => {
            return this.setCellColor(params.data, params.colDef.field)
          },
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input',
            attrs: {
              complexTextConverter: (data, val) => {
                let precision = 0
                if (this.jsSendHide) {
                  precision = 3
                }
                return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, precision))
              }
            },
            valueChanged: p => {
              this.packageInfoChanged(p)
            }
          }
        }, {
          headerName: this.getItemTitle('Volume'),
          headerTooltip: this.$t('SeaExport.Cubage'),
          colId: 'cubage',
          field: 'cubage',
          width: 160,
          cellStyle: (params) => {
            return this.setCellColor(params.data, params.colDef.field)
          },
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input',
            attrs: {
              complexTextConverter: (data, val) => {
                return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 3))
              }
            },
            valueChanged: p => {
              this.packageInfoChanged(p)
            }
          }
        }
      ]
      const notJsDefs = [
        {
          headerName: this.getItemTitle('Container Type'),
          headerTooltip: this.$t('SeaExport.BoxSpecies'),
          colId: 'eqType',
          field: 'eqType',
          width: 160,
          cellStyle: (params) => {
            return this.setCellColor(params.data, params.colDef.field)
          }
        }
      ]
      const columnDef = [
        {
          headerName: this.isChineseLanguage ? '件数' : 'Quantity',
          headerTooltip: this.$t('SeaExport.itemCount'),
          colId: 'quantity',
          field: 'quantity',
          width: 160,
          cellStyle: (params) => {
            return this.setCellColor(params.data, params.colDef.field)
          },
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input',
            attrs: {
              complexTextConverter: (data, val) => {
                return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 0))
              }
            },
            valueChanged: p => {
              this.packageInfoChanged(p)
            }
          }
        }, {
          headerName: this.getItemTitle('Unit Type'),
          headerTooltip: this.$t('SeaExport.Packing'),
          colId: 'packing',
          field: 'packing',
          width: 160,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Packing, 'code', this.form.packing, 'name')
          },
          cellStyle: (params) => {
            return this.setCellColor(params.data, params.colDef.field)
          }
        },
        {
          headerName: this.getItemTitle('Goods'),
          headerTooltip: this.$t('SeaExport.CommodityName'),
          colId: 'cargoName',
          field: 'cargoName',
          width: 120,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridAdvanceTextEditor',
          cellEditorParams: {
            fitContent: true,
            title: this.getItemTitle('Goods')
          }
        },
        {
          headerName: this.getItemTitle('Marks'),
          headerTooltip: this.$t('SeaExport.ShippingMark'),
          colId: 'mark',
          field: 'mark',
          width: 100,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridAdvanceTextEditor',
          cellEditorParams: {
            fitContent: true,
            title: this.getItemTitle('Marks')
          }
        },
        {
          headerName: this.getItemTitle('HS CODE'),
          headerTooltip: this.$t('SeaExport.HsCode'),
          colId: 'hsCodeContainer',
          field: 'hsCodeContainer',
          width: 80,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          onCellValueChanged: (params) => {
            this.hsCodeChanged(params)
          }
        }
      ]
      const columnDefJs = [
        {
          headerName: this.getItemTitle('Container Owner'),
          colId: 'containerOwnershipCode',
          field: 'containerOwnershipCode',
          cellEditor: 'CargoAgGridSelectEditor',
          editable: this.isEdit,
          cellEditorParams: {
            selectProps: {
              filterable: true
            },
            options: SystemConstants.JS_AFR_CONTAINER_OWNER,
            tagName: 'chineseName',
            tagValue: 'code'
          },
          valueFormatter: params => {
            return CommonState.getNameByCode(SystemConstants.JS_AFR_CONTAINER_OWNER, params.value)
          }
        }, {
          headerName: this.getItemTitle('Container Type'),
          headerTooltip: this.$t('SeaExport.BoxSpecies'),
          colId: 'eqType',
          field: 'eqType',
          cellEditor: 'CargoAgGridSelectEditor',
          editable: this.isEdit,
          cellEditorParams: {
            selectProps: {
              filterable: true
            },
            options: SystemConstants.JS_AFR_CONTAINER_TYPE,
            tagName: 'chineseName',
            tagValue: 'code'
          },
          valueFormatter: params => {
            return CommonState.getNameByCode(SystemConstants.JS_AFR_CONTAINER_TYPE, params.value)
          }
        },
        {
          headerName: this.getItemTitle('Container Height'),
          headerTooltip: this.$t('SeaExport.BoxHeight'),
          colId: 'eqHeight',
          field: 'eqHeight',
          cellEditor: 'CargoAgGridSelectEditor',
          editable: this.isEdit,
          cellEditorParams: {
            selectProps: {
              filterable: true
            },
            options: SystemConstants.JS_AFR_CONTAINER_HEIGHT,
            tagName: 'chineseName',
            tagValue: 'code'
          },
          valueFormatter: params => {
            return CommonState.getNameByCode(SystemConstants.JS_AFR_CONTAINER_HEIGHT, params.value)
          }
        }]
      if (this.jsSendHide) {
        return [...columnDefs, ...columnDefJs]
      } else {
        return [...columnDefs, ...columnDef, ...notJsDefs]
      }
    },
    containerFinalRowData() {
      return this.container.rowData.filter(p => !p.deleted)
    },
    masterInfoColumnDefs() {
      return [
        {
          headerName: this.amsTitle,
          headerTooltip: this.amsTitleCn,
          colId: 'jobNo',
          field: 'jobNo',
          flex: 1,
          width: 260
        }, {
          headerName: this.getItemTitle('Send Status'),
          headerTooltip: this.$t('SeaExport.SendingStatus'),
          colId: 'afrSendState',
          field: 'afrSendState',
          flex: 1,
          width: 260,
          cellRenderer: params => {
            return this.pm.setStatus(params.value)
          },
          tooltipValueGetter: (params) => {
            return this.pm.setStatus(params.value, true)
          }
        }, {
          headerName: this.getItemTitle('Receipt'),
          headerTooltip: this.$t('SeaExport.ReceiptStatus'),
          colId: 'afrReceiptStatus',
          field: 'afrReceiptStatus',
          flex: 1,
          width: 260
        }
      ]
    },
    afr2ColumnDefs() {
      return [
        {
          headerName: this.getItemTitle('Job No'),
          colId: 'jobNo',
          field: 'jobNo',
          flex: 1,
          width: 260
        }, {
          headerName: 'HB/L',
          colId: 'hblNbr2',
          field: 'hblNbr2',
          flex: 1,
          width: 260
        }, {
          headerName: 'Status',
          headerTooltip: this.$t('SeaExport.SendingStatus'),
          hide: this.isJs, suppressColumnsToolPanel: this.isJs,
          colId: 'afrStatus',
          field: 'afrStatus',
          flex: 1,
          width: 260,
          cellRenderer: params => {
            return this.pm.setStatus(params.value)
          },
          tooltipValueGetter: (params) => {
            return this.pm.setStatus(params.value, true)
          }
        },
        {
          headerName: this.getItemTitle('Send Status'),
          hide: !this.isJs, suppressColumnsToolPanel: !this.isJs,
          headerTooltip: this.$t('SeaExport.SendingStatus'),
          colId: 'jsAfrStatus',
          field: 'jsAfrStatus',
          flex: 1,
          width: 260,
          cellRenderer: params => {
            return this.pm.setJsStatus(params.value)
          },
          tooltipValueGetter: (params) => {
            return this.pm.setJsStatus(params.value, true)
          }
        },
        {
          headerName: 'Receipt',
          headerTooltip: this.$t('SeaExport.ReceiptStatus'),
          hide: this.isJs, suppressColumnsToolPanel: this.isJs,
          colId: 'afrReceiptStatus',
          field: 'afrReceiptStatus',
          flex: 1,
          width: 260
        },
        {
          headerName: this.getItemTitle('Receipt'),
          hide: !this.isJs, suppressColumnsToolPanel: !this.isJs,
          headerTooltip: this.$t('SeaExport.ReceiptStatus'),
          colId: 'jsAfrReceiptStatus',
          field: 'jsAfrReceiptStatus',
          flex: 1,
          width: 260,
          cellRenderer: params => {
            return this.pm.setJsAfrReceiptStatus(params.value)
          }
        },
        {
          headerName: this.getItemTitle('Last'),
          colId: 'afrLast',
          field: 'afrLast',
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'el-checkbox',
            valueChanged: p => { this.pm.onLastChange(p) }
          }
        }
      ]
    },
    columnDefs() {
      return [
        {
          headerName: 'AFR NO',
          field: 'ams',
          width: 200
        },
        {
          headerName: this.getItemTitle('Receipt Status'),
          field: 'receiptCode',
          width: 200,
          cellRenderer: params => {
            return this.pm.setJsAfrReceiptStatus(params.value)
          }
        },
        {
          headerName: this.getItemTitle('Description'),
          field: 'remark',
          width: 375
        },
        {
          headerName: this.getItemTitle('Code'),
          field: 'errorCode',
          width: 375
        },
        {
          headerName: this.getItemTitle('Solution'),
          field: 'solutions',
          width: 375
        },
        {
          headerName: this.getItemTitle('Time'),
          field: 'receiptDate',
          width: 200
        }
      ]
    },
    // 是否是危险品
    isDangerousCargo() {
      return this.form.goodsType === 1
    },
    jsSendHide() {
      return this.isJs && this.saveAs === '1'
    }
  },
  watch: {
    activeTabName(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$refs[this.activeTabName].onShow()
        this.pm.changeIsfActiveTab(this.activeTabName)
      }
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    const cacheConfig = cache.config
    this.visible = true
    this.isTradetech = this.config.get('AMSInterfaceName') === 'tradetech'
    this.isChineseLanguage = Number(cacheConfig.get('AntiTerrorismShippingAfrLanguageSwitching')) === 1
    this.setNameOfCountry()
  },
  methods: {
    setNameOfCountry(p) {
      this.localData.nameOfCountry = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Country, 'code', p ? p.value : this.form.countryOrigin, 'name')
    },
    finishAdvanceText() {
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(this.advanceTextDialog.value)
      }
      this.advanceTextDialog.visible = false
    },
    packageInfoChanged(params) {
      if (this.form.docType === CargoDocConsts.AFR) {
        let sum = 0
        for (const item of this.container.rowData) {
          if (item.deleted) {
            continue
          }
          sum += Number(item[params.field])
        }
        this.form[params.field] = sum
      }
    },
    hsCodeChanged(params) {
      for (const item of this.container.rowData) {
        if (item.deleted) {
          continue
        }
        item.hsCodeContainer = params.newValue
      }
      if (this.form.docType === CargoDocConsts.AFR) {
        this.form.hsCode = params.newValue
      }
      this.container.gridOptions.api.refreshCells({ force: true })
    },
    hsCodeInputChanged(data) {
      if (data && data.length > 6) {
        this.form.hsCode = data.substring(0, 6)
      }
      this.container.rowData.forEach(item => {
        if (item.deleted) {
          return
        }
        item.hsCodeContainer = this.form.hsCode
      })
      this.container.gridOptions.api.refreshCells({ force: true })
    },
    /**
     * 移除装箱信息
     */
    removeContainerUsageClickHandler() {
      const rows = this.container.gridApi.getSelectedRows()
      if (rows.length === 0) {
        return
      }
      for (const row of rows) {
        if (row.uuid) {
          row.deleted = true
        } else {
          const index = this.container.rowData.findIndex(p => p === row)
          if (index >= 0) {
            this.container.rowData.splice(index, 1)
          }
        }
      }
      const tempRowData = this.container.rowData
      this.container.rowData = []
      this.$nextTick(() => {
        this.container.rowData = tempRowData
        if (this.form.docType === CargoDocConsts.AFR) {
          this.pm.refreshEdiGrid()
        }
      })
    },
    commandHandle(command) {
      switch (command) {
        case 'Code Searching':
          this.billAddressDialog.visible = true
          break
        case 'Copy Last Time':
          this.pm.onCopy1()
          break
        case 'Copy By File NO':
          Object.assign(this.afrSearchBillNoDialog.params, {
            docType: 'AFR',
            selectType: 'single',
            job: this.job
          })
          this.afrSearchBillNoDialog.visible = true
          break
      }
    },
    codeSearchCallback(data) {
      if (data.shipperInfo) {
        this.splitShipperLine(data.shipperInfo)
      }
      if (data.consigneeInfo) {
        this.splitConsigneeLine(data.consigneeInfo)
      }
      if (data.notifyInfo) {
        this.splitNotifyLine(data.notifyInfo)
      }
    },
    // 组装打印参数
    getPrintData() {
      if (!this.form || !this.form.uuid) {
        this.$message.warning(this.$t('Message.NoSelectedCargoDocInformation'))
      }
      const params = {}
      params.BLNbr2 = this.form.hblNbr2
      params.cargoDocUuid = this.form.uuid
      params.DOC_UUID = this.form.uuid
      params.category = 'AMS'
      params.ctx = new SeaCargoDoc(this.form)
      return params
      // TemplateSelectorWin.getInstance().showThisWin(view.cargoDoc, 'AMS', params, view)
    },
    hblNbr2Change() {
      const gridApi = this.afr2.gridApi
      gridApi.refreshCells()
      this.$nextTick(() => {
        if (this.curAfr) {
          const { rowsToDisplay } = gridApi.getModel()
          const selectedNode = rowsToDisplay.find(node => node.data.hblNbr2 === this.curAfr.hblNbr2)
          selectedNode.setSelected(true)
        }
      })
    },
    amsRadioChangeHandler() {
      this.pm.AMSTypeChangeHandler(this.form.AMSType)
      this.AMSTypeChange(this.form.AMSType)
    },
    getValueFromChild(obj) {
      this.form[obj.key] = obj.value
    },
    showShipperDialog() {
      this.showAdvanceTextDialog(this.$t('SeaExport.Shipper'), this.mergeShipperLine(), this.splitShipperLine, true, {
        maxChar: this.maxChars, autoUppercase: true, autoHalfWord: true
      })
    },
    showConsigneeDialog() {
      this.showAdvanceTextDialog(this.$t('SeaExport.Consignee'), this.mergeConsigneeLine(), this.splitConsigneeLine, true, {
        maxChar: this.maxChars, autoUppercase: true, autoHalfWord: true
      })
    },
    showNotifyDialog() {
      this.showAdvanceTextDialog(this.$t('SeaExport.NotifyParty'), this.mergeNotifyLine(), this.splitNotifyLine, true, {
        maxChar: this.maxChars, autoUppercase: true, autoHalfWord: true
      })
    },
    wrapAddr(source, from, to, maxChars) {
      CargoDocUtil.sftAddrInputWrap.call(this, source, from, to, maxChars)
    },
    showAdvanceTextDialog(title, value, successCallback, isUppercase = false, formatObj = null) {
      this.advanceTextDialog.title = title
      this.advanceTextDialog.value = value
      this.advanceTextDialog.successCallback = successCallback
      this.advanceTextDialog.isUppercase = isUppercase
      this.advanceTextDialog.visible = true
      this.$nextTick(() => {
        this.$refs.advanceTextDialogTextarea.editor.focus()
      })
      const defaultFormatObj = {
        maxChar: 45, autoUppercase: false, autoHalfWord: false
      }
      this.advanceTextDialog.formatObj = formatObj ? { ...defaultFormatObj, ...formatObj } : defaultFormatObj
    },
    mergeShipperLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.form['shipperLine' + i] || ''
        result += '\n'
      }
      result += (this.form['shipperLine7'] || '')
      return result.trimEnd()
    },
    splitShipperLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.form['shipperLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.form['shipperLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.form['shipperLine' + i] = ''
      }
    },
    mergeConsigneeLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.form['consigneeLine' + i] || ''
        result += '\n'
      }
      result += (this.form['consigneeLine7'] || '')
      return result.trimEnd()
    },
    splitConsigneeLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.form['consigneeLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.form['consigneeLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.form['consigneeLine' + i] = ''
      }
    },
    mergeNotifyLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.form['notifyLine' + i] || ''
        result += '\n'
      }
      result += (this.form['notifyLine7'] || '')
      return result.trimEnd()
    },
    portChange(p, portCodeField, portNameField) {
      const form = this.form
      form[portCodeField] = p.value
      form[portNameField] = p.englishName
      this.pm.syncAfrInfo(portCodeField)
      this.pm.syncAfrInfo(portNameField)
    },
    // 第三方数据
    portChange2(p, portCodeField, portNameField) {
      const form = this.form
      form[portCodeField] = p.value
      form[portNameField] = p.name
      this.pm.syncAfrInfo(portCodeField)
      this.pm.syncAfrInfo(portNameField)
    },
    splitNotifyLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.form['notifyLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.form['notifyLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.form['notifyLine' + i] = ''
      }
    },
    showSenderAndReceiverDialog(type, count, isAmsAndManifest = false) {
      const value = !isAmsAndManifest ? this.mergeSenderAndReceiverLine(type, count) : this.mergeSenderAndReceiverLineForAmsAndManifest(type, count)
      switch (type) {
        case 'shipper':
          this.advanceTextDialog.title = this.$t('SeaExport.Shipper')
          break
        case 'consignee':
          this.advanceTextDialog.title = this.$t('SeaExport.Consignee')
          break
        case 'notifyLine':
          this.advanceTextDialog.title = this.$t('SeaExport.Notifier')
          break
        case 'alsonotifyLine':
          this.advanceTextDialog.title = this.$t('SeaExport.SecondNotifier')
          break
      }
      this.advanceTextDialog.value = value
      this.advanceTextDialog.successCallback = () => !isAmsAndManifest ? this.splitSenderAndReceiverLine(type, count, this.advanceTextDialog.value) : this.splitSenderAndReceiverLineForAmsAndManifest(type, count, this.advanceTextDialog.value)
      this.advanceTextDialog.visible = true
    },
    mergeSenderAndReceiverLine(type, count) {
      const addressForm = this.form.afrAddress[0]
      let result = ''
      for (let i = 1; i < count; ++i) {
        result += addressForm[`${type}Line${i}`] || ''
        result += '\n'
      }
      result += (addressForm[`${type}Line${count}`] || '')
      return result.trimEnd()
    },
    splitSenderAndReceiverLine(type, count, val) {
      const addressForm = this.form.afrAddress[0]
      let fromIndex = 0
      let i = 1
      for (; i < count; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          addressForm[`${type}Line${i}`] = ''
          continue
        }
        addressForm[`${type}Line${i}`] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      addressForm[`${type}Line${i}`] = val.substring(fromIndex)
    },
    // AMS 和 EManifest 页签使用
    mergeSenderAndReceiverLineForAmsAndManifest(type, count) {
      const addressForm = this.form.afrAddress[0]
      let result = ''
      for (let i = 1; i < count; ++i) {
        let no = i
        if (i !== 1) {
          no = (i + 1)
        }
        result += addressForm[`${type}Line${no}`] || ''
        result += '\n'
      }
      result += (addressForm[`${type}Line${count + 1}`] || '')
      return result.trimEnd()
    },
    // AMS 和 EManifest 页签使用
    splitSenderAndReceiverLineForAmsAndManifest(type, count, val) {
      const addressForm = this.form.afrAddress[0]
      let fromIndex = 0
      let i = 1
      let no = 1
      for (; i < count; ++i) {
        no = (i !== 1) ? (i + 1) : i
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          addressForm[`${type}Line${no}`] = ''
          continue
        }
        addressForm[`${type}Line${no}`] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      addressForm[`${type}Line${no + 1}`] = val.substring(fromIndex)
    },
    isDifferent(field) {
      return this.localData.importDifferentField && this.localData.importDifferentField.hasOwnProperty(field) ? 'warning' : ''
    },
    changeUnitType(p) {
      this.form.packing = p.value
      this.container.gridOptions.api.clearFocusedCell()
      this.container.gridOptions.api.refreshCells({ force: true })
    },
    setCellColor(data, field) {
      const importDifferentField = this.localData.importDifferentField
      if (!importDifferentField ||
        !importDifferentField.container ||
        !importDifferentField.container[data.containerNo]) {
        return {}
      }
      if (importDifferentField.container[data.containerNo].hasOwnProperty(field)) {
        return { 'color': 'red' }
      }
      return {}
    },
    selectSubLoc(type) {
      this.selectSubLocDialog.type = type
      this.selectSubLocDialog.visible = true
    },
    selectSubLocCallBack(row, type) {
      if (type === 1) {
        if (row) {
          this.form.dishSubLoc = row.subLocationCode
          this.localData.dishSubLocStr = row.subLocationCode + '-' + row.aciPortCode + '-' + row.inlandLocation
        } else {
          this.form.dishSubLoc = ''
          this.localData.dishSubLocStr = ''
        }
      } else if (type === 2) {
        if (row) {
          this.form.subLocationCode = row.subLocationCode
          this.localData.subLocationCodeStr = row.subLocationCode + '-' + row.aciPortCode + '-' + row.inlandLocation
        } else {
          this.form.subLocationCode = ''
          this.localData.subLocationCodeStr = ''
        }
      }
      this.selectSubLocDialog.visible = false
    },
    changeDispatchingPlace(p) {
      this.form.dispatchingPlace = p.code
    },
    changeVoyage() {
      this.form.voyageFlight = CargoDocUtil.replaceVoyage(this.form.voyageFlight, true)
      this.pm.syncAfrInfo('voyageFlight')
    },
    queryReceipt(data) {
      this.receiptDialog.visible = true
      this.receiptDialog.rowData = data || []
    },
    openCheckTip(data) {
      this.checkDialog.visible = true
      // 去重
      const uniqueMap = new Map()
      if (data) {
        data.forEach(item => {
          const key = item.field + '|' + item.errorDescription
          if (!uniqueMap.has(key)) {
            uniqueMap.set(key, item)
          }
        })
      }
      this.checkDialog.rowData = Array.from(uniqueMap.values())
    },
    getItemTitle(targetCode) {
      if (this.isChineseLanguage) {
        return ColumnUtils.afrLabelFunc(targetCode)
      }
      return targetCode
    }
  }
}
</script>

<style lang="scss">
  .afr-info{
    .warning .el-input__inner{
      color: red !important;
    }
    .warning{
      color: red !important;
    }
    .el-radio__label{
      font-size: 12px;
      font-weight: normal;
      color: #333333 !important;
    }
    .el-checkbox__label{
      font-weight: normal;
      color: #333333 !important;
    }
    .el-form-item__label {
      width: 120px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
</style>
